import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  Tooltip,
  IconButton,
} from "@mui/material";
import { PlayArrow, Info } from "@mui/icons-material";
import { getVodInfo, getSeriesInfo } from "../../other/load-playlist";
import { optimizeName } from "../../other/vod-series-name-optimizer";

const BackgroundPlayer = ({
  name,
  stream_icon,
  stream_id,
  category_id,
  isSeries,
  style,
  title,
  existingTmdb,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [ImageSrc, setImageSrc] = useState(stream_icon);
  const [Description, setDescription] = useState("");
  const [youtubeId, setYoutubeId] = useState(null);
  const [backdropPath, setBackdropPath] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const infoFunction = isSeries ? getSeriesInfo : getVodInfo;
      console.log('isSeries', isSeries, stream_id, name, existingTmdb);
      const result = await infoFunction(stream_id, name, true, existingTmdb);
      console.log('result', result);
      if (result && result.info) {
        const info = result.info;
        setResult(result);
        if (info.image) setImageSrc(info.image);
        if (info.cover) setImageSrc(info.cover);
        if (info.description) setDescription(info.description);
        if (info.youtube_trailer) setYoutubeId(info.youtube_trailer);
        if (info.backdrop_path && info.backdrop_path.length > 0)
        setBackdropPath(info.backdrop_path[0]);
      }
    }
    fetchData();
  }, [stream_id, name, isSeries, existingTmdb]);

  if (!result) return null;

  const {
    movie_image,
    name: movieName,
    plot,
    genre,
    cast,
    rating,
    director,
    youtube_trailer,
    releasedate,
  } = result.info;

  return (
    <Box
      style={style}
      sx={{
        height: "calc(75vh - 3rem)",
        position: "relative",
      }}
    >
      {youtubeId || !backdropPath ? (
        <Box
          sx={{
            position: "absolute",
            width: "100vw",
            height: "calc(75vh - 4rem)",
            top: 0,
            left: 0,
            overflow: "hidden",
          }}
        >
          {youtubeId && (
            <iframe
              frameBorder="0"
              height="100%"
              width="100%"
              title="youtube-bg"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "200%",
                width: "200%%",
                marginTop: "-350px",
              }}
              src={`https://youtube.com/embed/${youtubeId}?autoplay=1&controls=0&showinfo=0&autohide=1&mute=1&loop=1&disablekb=1&modestbranding=1&playlist=${youtubeId}&origin=http://localhost:3006`}
            ></iframe>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            height: "calc(75vh - 4rem)",
            top: 0,
            left: 0,
            zIndex: -1,
            width: "100vw",
          }}
        />
      )}
      <Box
        sx={{
          color: "white",
          position: "absolute",
          width: "100vw",
          height: "calc(70vh - 3rem)",
          zIndex: 2,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                borderRadius: "8px",
                padding: "2rem",
                marginLeft: "2rem",
                marginTop: "2rem",
              }}
            >
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {movieName}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "1rem",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {plot}
              </Typography>
              <Typography
                variant="body2"
                sx={{ marginBottom: "0.5rem", color: "gray" }}
              >
                <strong>Genre:</strong> {genre}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "0.5rem",
                  color: "gray",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <strong>Cast:</strong> {cast}
              </Typography>
              <Typography
                variant="body2"
                sx={{ marginBottom: "0.5rem", color: "gray" }}
              >
                <strong>Director:</strong> {director}
              </Typography>
              <Typography
                variant="body2"
                sx={{ marginBottom: "0.5rem", color: "gray" }}
              >
                <strong>Release Date:</strong> {releasedate}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: "inline-block",
                  padding: "0.25rem 0.5rem",
                  backgroundColor: "gray",
                  borderRadius: "4px",
                  color: "white",
                }}
              >
                Rating: {rating}
              </Typography>
              <Box
                sx={{
                  marginTop: "1rem",
                  display: "flex",
                  gap: "1rem",
                }}
              >
                {!isSeries && (
                  <Tooltip title="Play">
                    <IconButton
                      component={Link}
                      to={`/movie/category/${category_id}/${stream_id}/play/`}
                      color="inherit"
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      <PlayArrow />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="More Info">
                  <IconButton
                    component={Link}
                    to={`/${
                      isSeries ? "series" : "movie"
                    }/category/${category_id}/${stream_id}/info/`}
                    color="inherit"
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <Info />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          position: "absolute",
          width: "100vw",
          height: "23vh",
          bottom: 0,
          left: 0,
          zIndex: 0,
        }}
      />
    </Box>
  );
};

export default BackgroundPlayer;
